import produce from 'immer';

import { snakeToCamel } from '@iso/lib/helpers/keyNormalizer';

import * as CONSTANTS from './constants';

const initialState = {
  loading: false,
  companies: [],
  company: null,
  profile: null,
  isOpenCreateCompanyModal: false,
  isPlaidCompanyConnectFailed: false,
  // create: {
  //   loading: false,
  //   error: null,
  // },
  // TODO: combine with company field
  companyRequest: {
    loading: false,
    error: null
  },
  detail: {
    loading: false,
    error: null
  },
  // fetchProfile: {
  //   loading: true,
  //   error: null,
  // },
  // updateProfile: {
  //   loading: true,
  //   error: null,
  // },
  accept: {
    loading: true,
    error: null
  },
  decline: {
    loading: true,
    error: null
  },
  // companyType: {
  //   loading: false,
  //   error: null,
  // },
  companyTypeList: [],
  // businessType: {
  //   loading: false,
  //   error: null,
  // },
  businessTypeList: [],
  companyWallet: {
    loading: false,
    error: null,
    wallet: null
  },
  silaKYB: {
    loading: false,
    error: null,
    silaKYB: {}
  },
  silaCompany: {
    loading: false,
    error: null,
    companyInfo: null
  },
  kybUpload: {
    loading: false,
    error: null,
    success: null,
    data: null
  },
  plaidLinkKYB: {
    token: null,
    loading: false,
    error: null,
    connected: false,
  },
  plaidCompanyAccount: {
    account: null,
    loading: false,
    error: null
  },
  plaidVerifyCompanyAccount: {
    accounts: [],
    loading: false,
    error: null
  },
  plaidCompanyAccountRemove: {
    success: null,
    loading: false,
    error: null
  },
  paidInvoices: {
    loading: false,
    error: null,
    success: false
  },
  // requestSignIntoCompany: {
  //   loading: false,
  //   error: null,
  //   success: false,
  // },
  companyWalletBal: {
    loading: false,
    error: null,
    status: null
  },
  deletedCompanyAccount: {
    loading: false,
    error: null,
    status: null
  },
  displayWalletNotSetModal: false,
  payrollData: {
    loading: false,
    error: null,
    url: null
  }
};

const companyReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CONSTANTS.FETCH_COMPANIES_REQUEST:
        draft.loading = true;
        break;
      case CONSTANTS.FETCH_COMPANIES_SUCCESS:
        draft.companies = action.companies;
        draft.loading = false;
        break;
      case CONSTANTS.FETCH_COMPANIES_FAIL:
        draft.loading = false;
        break;

      case CONSTANTS.FETCH_COMPANY_DETAIL_REQUEST:
        draft.detail = { loading: true, error: null };
        break;
      case CONSTANTS.FETCH_COMPANY_DETAIL_SUCCESS:
        draft.company = action.data;
        draft.detail = { loading: false, error: null };
        break;
      case CONSTANTS.FETCH_COMPANY_DETAIL_FAIL:
        draft.detail = { loading: false, error: action.error };
        break;
      case CONSTANTS.CLEAR_COMPANY:
        draft.company = null;
        break;

      // case CONSTANTS.FETCH_COMPANY_PROFILE_REQUEST:
      //   draft.fetchProfile = { loading: true, error: null };
      //   break;
      case CONSTANTS.FETCH_COMPANY_PROFILE_SUCCESS:
        draft.profile = action.data;
        // draft.fetchProfile = { loading: false, error: null };
        break;
      // case CONSTANTS.FETCH_COMPANY_PROFILE_FAIL:
      //   draft.fetchProfile = { loading: false, error: action.error };
      //   break;

      case CONSTANTS.UPDATE_COMPANY_PROFILE_REQUEST:
        // draft.updateProfile = { loading: true, error: null };
        break;
      case CONSTANTS.UPDATE_COMPANY_PROFILE_SUCCESS:
        draft.profile = action.data;
        // draft.updateProfile = { loading: false, error: null };
        break;
      // case CONSTANTS.UPDATE_COMPANY_PROFILE_FAIL:
      //   draft.updateProfile = { loading: false, error: action.error };
      //   break;

      case CONSTANTS.CREATE_COMPANY_REQUEST:
        // draft.create = { loading: true, error: null };
        break;
      case CONSTANTS.CREATE_COMPANY_SUCCESS:
        // draft.create = { loading: false, error: null };
        draft.company = action.data;
        break;
      case CONSTANTS.CREATE_COMPANY_FAIL:
        draft.company = { loading: false, error: action.error };
        break;

      case CONSTANTS.UPDATE_COMPANY:
      case CONSTANTS.UPDATE_COMPANY_REQUEST:
        draft.companyRequest = { loading: true, error: null };
        break;
      case CONSTANTS.UPDATE_COMPANY_SUCCESS:
        draft.company = action.data;
        draft.companyRequest = { loading: false, error: null };
        break;
      case CONSTANTS.UPDATE_COMPANY_FAIL:
        draft.companyRequest = { loading: false, error: action.error };
        break;

      case CONSTANTS.ACCEPT_COMPANY_PERMISSION_BY_OWNER_REQUEST:
        draft.accept = { loading: true, error: null };
        break;
      case CONSTANTS.ACCEPT_COMPANY_PERMISSION_BY_OWNER_SUCCESS:
        draft.accept = { loading: false, error: null };
        break;
      case CONSTANTS.ACCEPT_COMPANY_PERMISSION_BY_OWNER_FAIL:
        draft.accept = { loading: false, error: action.error };
        break;

      case CONSTANTS.DECLINE_COMPANY_PERMISSION_BY_OWNER_REQUEST:
        draft.decline = { loading: true, error: null };
        break;
      case CONSTANTS.DECLINE_COMPANY_PERMISSION_BY_OWNER_SUCCESS:
        draft.decline = { loading: false, error: null };
      case CONSTANTS.DECLINE_COMPANY_PERMISSION_BY_OWNER_FAIL:
        draft.decline = { loading: false, error: action.error };
        break;

      // case CONSTANTS.FETCH_COMPANY_TYPE_REQUEST:
      //   draft.companyType = { loading: true, error: null };
      //   break;
      case CONSTANTS.FETCH_COMPANY_TYPE_SUCCESS:
        draft.companyTypeList = action.data;
        // draft.companyType = { loading: false, error: null };
        break;
      // case CONSTANTS.FETCH_COMPANY_TYPE_FAIL:
      //   draft.companyType = { loading: false, error: action.error };
      //   break;

      // case CONSTANTS.FETCH_BUSINESS_TYPE_REQUEST:
      //   draft.businessType = { loading: true, error: null };
      //   break;
      case CONSTANTS.FETCH_BUSINESS_TYPE_SUCCESS:
        draft.businessTypeList = action.data;
        // draft.businessType = { loading: false, error: null };
        break;
      // case CONSTANTS.FETCH_BUSINESS_TYPE_FAIL:
      //   draft.businessType = { loading: false, error: action.error };
      //   break;

      case CONSTANTS.REGISTER_SILA_COMPANY:
        draft.silaCompany = {
          loading: true,
          error: null,
          companyInfo: null
        };
        break;
      case CONSTANTS.REGISTER_SILA_COMPANY_SUCCESS:
        draft.silaCompany = {
          loading: false,
          error: null,
          companyInfo: action.data
        };
        break;
      case CONSTANTS.REGISTER_SILA_COMPANY_FAIL:
        draft.silaCompany = {
          loading: false,
          error: action.error,
          companyInfo: null
        };
        break;

      case CONSTANTS.UPDATE_SILA_COMPANY:
        draft.silaCompany = {
          loading: true,
          error: null,
          companyInfo: null
        };
        break;
      case CONSTANTS.UPDATE_SILA_COMPANY_SUCCESS:
        draft.silaCompany = {
          loading: false,
          error: null,
          companyInfo: action.data
        };
        break;
      case CONSTANTS.UPDATE_SILA_COMPANY_FAIL:
        draft.silaCompany = {
          loading: false,
          error: action.error,
          companyInfo: null
        };
        break;

      case CONSTANTS.GET_COMPANY_WALLET:
        draft.companyWallet = {
          ...draft.companyWallet,
          loading: true,
          error: null
        };
        break;
      case CONSTANTS.GET_COMPANY_WALLET_SUCCESS:
        draft.companyWallet = {
          loading: false,
          error: null,
          wallet: action.data
        };
        break;
      case CONSTANTS.GET_COMPANY_WALLET_FAIL:
        draft.companyWallet = {
          loading: false,
          error: action.error,
          wallet: null
        };
        break;

      case CONSTANTS.GET_SILA_COMPANY:
        draft.silaCompany = {
          loading: true,
          error: null,
          companyInfo: null
        };
        break;
      case CONSTANTS.GET_SILA_COMPANY_SUCCESS:
        draft.silaCompany = {
          loading: false,
          error: null,
          companyInfo: action.data
        };
        break;
      case CONSTANTS.GET_SILA_COMPANY_FAIL:
        draft.silaCompany = {
          loading: false,
          error: action.error,
          companyInfo: null
        };
        break;

      case CONSTANTS.GET_COMPANY_SILA_VERIFICATION:
        draft.silaKYB = { ...draft.silaKYB, loading: true, error: null };
        break;
      case CONSTANTS.GET_COMPANY_SILA_VERIFICATION_SUCCESS:
        draft.silaKYB = {
          loading: false,
          error: null,
          silaKYB: {
            ...action.data,
            resultDetail: [...action.data.resultDetail].filter(
              (item) => ![''].includes(item)
            )
          }
        };
        break;
      case CONSTANTS.GET_COMPANY_SILA_VERIFICATION_FAIL:
        draft.silaKYB = {
          loading: false,
          error: action.error,
          silaKYB: {}
        };
        break;

      case CONSTANTS.POST_COMPANY_REQUEST_KYB:
        draft.silaKYB = { loading: true, error: null, silaKYB: {} };
        break;
      case CONSTANTS.POST_COMPANY_REQUEST_KYB_SUCCESS:
        draft.silaKYB = {
          loading: false,
          error: null,
          silaKYB: action.data
        };
        break;
      case CONSTANTS.POST_COMPANY_REQUEST_KYB_FAIL:
        draft.silaKYB = {
          loading: false,
          error: action.error,
          silaKYB: {}
        };
        break;

      case CONSTANTS.UPLOAD_KYB_DOCUMENT_REQUEST:
        draft.kybUpload = {
          loading: true,
          error: null,
          success: null,
          data: null
        };
        break;
      case CONSTANTS.UPLOAD_KYB_DOCUMENT_SUCCESS:
        draft.kybUpload = {
          loading: false,
          error: null,
          success: 'KYB document uploaded successfully!',
          data: action.payload
        };
        break;
      case CONSTANTS.UPLOAD_KYB_DOCUMENT_FAIL:
        draft.kybUpload = {
          loading: false,
          error: action.error.error,
          success: null,
          data: null
        };
        break;

      case CONSTANTS.GET_PLAID_LINK_COMPANY_TOKEN_REQUEST:
        draft.plaidLinkKYB = {
          ...draft.plaidLinkKYB,
          loading: true,
          error: null,
          token: null,
          connected: false
        };
        break;
      case CONSTANTS.GET_PLAID_LINK_COMPANY_TOKEN_SUCCESS:
        draft.plaidLinkKYB = {
          ...draft.plaidLinkKYB,
          loading: false,
          error: null,
          token: action.data,
          connected: false
        };
        break;
      case CONSTANTS.PLAID_LINK_COMPANY_ACCOUNT_CONNECTED:
        draft.plaidLinkKYB = {
          loading: false,
          error: null,
          token: null,
          connected: true
        };
        break;
      case CONSTANTS.GET_PLAID_LINK_COMPANY_TOKEN_FAIL:
        draft.plaidLinkKYB = {
          loading: false,
          error: action.error,
          token: null,
          connected: false
        };
        break;

      case CONSTANTS.GET_PLAID_COMPANY_ACCOUNT_REQUEST:
        draft.plaidCompanyAccount = {
          ...draft.plaidCompanyAccount,
          loading: true,
          error: null
        };
        break;
      case CONSTANTS.GET_PLAID_COMPANY_ACCOUNT_SUCCESS:
        draft.plaidCompanyAccount = {
          loading: false,
          error: null,
          account: action.data
        };
        break;
      case CONSTANTS.GET_PLAID_COMPANY_ACCOUNT_FAIL:
        draft.plaidCompanyAccount = {
          loading: false,
          error: action.error,
          account: null
        };
        break;

      case CONSTANTS.GET_COMPANY_PLAID_VERIFY_ACCOUNT_REQUEST:
        draft.plaidVerifyCompanyAccount = {
          ...draft.plaidVerifyCompanyAccount,
          loading: true,
          error: null
        };
        break;

      case CONSTANTS.GET_COMPANY_PLAID_VERIFY_ACCOUNT_SUCCESS:
        draft.plaidVerifyCompanyAccount = {
          loading: false,
          error: null,
          accounts: action.data
        };
        break;

      case CONSTANTS.GET_COMPANY_PLAID_VERIFY_ACCOUNT_FAIL:
        draft.plaidVerifyCompanyAccount = {
          loading: false,
          error: action.error,
          accounts: []
        };
        break;

      case CONSTANTS.REMOVE_PLAID_COMPANY_ACCOUNT:
        draft.plaidCompanyAccountRemove = {
          loading: true,
          success: false,
          error: null
        };
        break;
      case CONSTANTS.REMOVE_PLAID_COMPANY_ACCOUNT_SUCCESS:
        draft.plaidCompanyAccountRemove = {
          loading: false,
          error: null,
          success: true
        };
        break;
      case CONSTANTS.REMOVE_PLAID_COMPANY_ACCOUNT_FAIL:
        draft.plaidCompanyAccountRemove = {
          loading: false,
          error: action.error,
          success: false
        };
        break;
      case CONSTANTS.FETCHING_COMPANY_WALLET_BAL_REQUEST:
        draft.companyWalletBal = {
          loading: true,
          error: null,
          status: null
        };
        break;
      case CONSTANTS.FETCHING_COMPANY_WALLET_BAL_SUCCESS:
        draft.companyWalletBal = {
          loading: false,
          error: null,
          status: action.data?.status
        };
        break;
      case CONSTANTS.FETCHING_COMPANY_WALLET_BAL_FAIL:
        draft.companyWalletBal = {
          loading: false,
          error: action.error,
          status: null
        };
        break;
      case CONSTANTS.FETCHED_COMPANY_WALLET_BAL_RESET:
        draft.companyWalletBal = {
          loading: false,
          error: null,
          status: null
        };
        break;
      case CONSTANTS.DELETE_COMPANY_ACCOUNT_REQUEST:
        draft.deletedCompanyAccount = {
          loading: true,
          error: null,
          status: null
        };
        break;
      case CONSTANTS.DELETE_COMPANY_ACCOUNT_SUCCESS:
        draft.deletedCompanyAccount = {
          loading: false,
          error: null,
          status: action.data?.status
        };
        break;
      case CONSTANTS.DELETE_COMPANY_ACCOUNT_FAIL:
        draft.deletedCompanyAccount = {
          loading: false,
          error: action.error,
          status: null
        };
        break;
      case CONSTANTS.DELETE_COMPANY_ACCOUNT_RESET:
        draft.deletedCompanyAccount = {
          loading: false,
          error: null,
          status: null
        };
        break;
      case CONSTANTS.TOGGLE_WALLET_NOT_SET_MODAL:
        draft.displayWalletNotSetModal = action.visible;
        break;
      case CONSTANTS.SET_COMPANY_PLAID_CONNECTION_FAILED:
        draft.isPlaidCompanyConnectFailed = action.payload;
        break;
      case CONSTANTS.GET_ZEAL_LOGIN_URL_REQUEST:
        draft.payrollData = {
          ...draft.payrollData,
          loading: true
        };
        break;
      case CONSTANTS.GET_ZEAL_LOGIN_URL_SUCCESS:
        draft.payrollData = {
          ...draft.payrollData,
          loading: false,
          url: action.data?.url
        };
        break;
      case CONSTANTS.GET_ZEAL_LOGIN_URL_FAIL:
        draft.payrollData = {
          ...draft.payrollData,
          loading: false,
          error: action.error?.message
        };
        break;

      case CONSTANTS.TRIGGER_CREATE_COMPANY_MODAL:
        draft.isOpenCreateCompanyModal = action.payload;
        break;

      default:
        break;
    }
  });

export default companyReducer;
